import dynamic from "next/dynamic";
import { buildClass } from "@utils/tag";
import { Icon, Text } from "@utils/helper";
import useTranslation from "next-translate/useTranslation";
import BtnBase from "@components/Buttons/BtnBase";
import { useSelector } from "noval";
import Link from "next/link";

const CustomImage = dynamic(() => import("@components/CustomImage"), {
  ssr: false,
});

const ShariaCompliance = () => {
  const screen = useSelector("screen");
  const { t, lang } = useTranslation("landing");

  return (
    <div className="bg-[#FFFFFF] -mt-px" id="sharia-section">
      <div className="base-container">
        <div className="py-6 sm:py-8 lg:py-[120px] flex flex-col gap-[72px] -mb-px">
          <div className="flex flex-col xl:flex-row gap-5 justify-between items-start">
            <div className="flex flex-col justify-between gap-5">
              <Text
                size={screen === "sm-phone" ? "30px" : "42px"}
                color="#011291"
                weight={600}
                className="leading-[52px]"
                fontType="Expo_sim"
              >
                {t("sharia_compliance.title")}
              </Text>
              <Link href={"/sharia-committee"}>
                <BtnBase
                  sx={{
                    width: "140.63px",
                    textTransform: "capitalize",
                    borderRadius: "10px",
                    backgroundColor: "#0366FF",
                    height: "43px",
                    padding: "0",
                    display: "flex",
                    gap: "8px",
                  }}
                  className="!font-Expo_sim !font-semibold"
                >
                  {t("sharia_compliance.learn_more")}

                  <span className="seo-text-reader">
                    {t("sharia_compliance.learn_more")}!
                  </span>
                  <Icon
                    id={"arrow-line"}
                    width={26}
                    height={26}
                    aria-hidden="true"
                    className={`${lang === "ar" ? "-rotate-90" : "rotate-0"}`}
                  />
                </BtnBase>
              </Link>
            </div>
            <Text
              size="20px"
              weight="400"
              className="leading-[30px] md:max-w-[551px]"
              color="#486AB5"
              fontType="Expo_bok"
            >
              {t("sharia_compliance.description")}
            </Text>
          </div>
          <div
            className={buildClass(
              "grid gap-5 justify-between",
              "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
            )}
          >
            {Array(4)
              .fill(0)
              .map((_, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center gap-5 max-w-[260px] mx-auto w-full justify-center"
                >
                  <CustomImage
                    width={260}
                    height={250}
                    src={`/images/landing/sharia/sharia_${index + 1}.png`}
                    alt={`sharia-${index + 1}`}
                    loading="lazy"
                  />
                  <div className="flex flex-col gap-4 text-center w-[260px]">
                    <div className="flex flex-col items-center">
                      {t(
                        `sharia_compliance.names.${index}`,
                        {},
                        { returnObjects: true }
                      ).map((name, idx) => (
                        <Text
                          key={idx}
                          size={idx === 0 ? "18px" : "20px"}
                          weight={idx === 0 ? 400 : 500}
                          color={idx === 0 ? "#486AB5" : "#011291"}
                          className="leading-[30px] mx-auto whitespace-pre-line"
                          fontType={idx === 0 ? "Expo_bok" : "Expo_sim"}
                        >
                          {name}
                        </Text>
                      ))}
                    </div>
                    <p className="text-center bg-[#F8FBFF] px-2 py-1 rounded-[40px]">
                      <Text
                        color="#0366FF"
                        weight="400"
                        className="leading-[21px]"
                        fontType="Expo_bok"
                      >
                        {t(`sharia_compliance.positions.${index}`)}
                      </Text>
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShariaCompliance;
